/* ==========================================================
   92point5 storefront behaviors
   1) Free-shipping progress bar in cart drawer + cart page
   2) Optional 18" chain add-on for pendants
   ========================================================== */
(function () {
  'use strict';

  /* ---------- 1. Free shipping progress ---------- */
  var THRESHOLD = 9900; // $99.00 in cents
  var cartTotal = null;
  var nativeFetch = window.fetch.bind(window);

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function markup(total) {
    var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
    var msg = total >= THRESHOLD
      ? 'Your order ships <strong>complimentary &amp; fully insured</strong>.'
      : 'You\u2019re <strong>' + money(THRESHOLD - total) + '</strong> away from complimentary insured shipping.';
    return '<p class="p5-ship__msg">' + msg + '</p>' +
      '<div class="p5-ship__track" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
  }

  function paint() {
    if (cartTotal === null) return;
    var totals = document.querySelectorAll('.totals');
    for (var i = 0; i < totals.length; i++) {
      var el = totals[i];
      var bar = el.previousElementSibling;
      if (!bar || !bar.classList || !bar.classList.contains('p5-ship')) {
        bar = document.createElement('div');
        bar.className = 'p5-ship';
        bar.setAttribute('role', 'status');
        el.parentNode.insertBefore(bar, el);
      }
      if (bar.dataset.total !== String(cartTotal)) {
        bar.dataset.total = String(cartTotal);
        bar.innerHTML = markup(cartTotal);
        bar.classList.toggle('is-unlocked', cartTotal >= THRESHOLD);
      }
      bar.hidden = cartTotal === 0;
    }
  }

  function refresh() {
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartTotal = cart.total_price; paint(); })
      .catch(function () {});
  }

  // Re-check the cart whenever the theme changes it
  window.fetch = function (input) {
    var p = nativeFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 150); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  // Re-insert the bar whenever the theme re-renders the drawer
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; paint(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  refresh();

  /* ---------- 2. Chain add-on for pendants ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.dataset.p5Pass === '1') { delete form.dataset.p5Pass; return; }

    var scope = form.closest('.shopify-section') || document;
    var box = scope.querySelector('.p5-addon__input:checked');
    if (!box) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var holder = box.closest('[data-p5-chain]');
    var chainId = Number(holder && holder.dataset.p5Chain);

    nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: chainId, quantity: 1 }] })
    })
      .catch(function () {})
      .then(function () {
        form.dataset.p5Pass = '1';
        if (form.requestSubmit) { form.requestSubmit(); }
        else { form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
      });
  }, true);
})();
